<template>
    <div class="columns settings is-multiline">
        <div class="column is-12">
            <div class="box" v-if="school">
                <h1 class="title"><i class="fa fa-house"></i> Skola {{school.name}} <a class="pull-right"
                                                                                       @click="goBack()">Tillbaka</a>
                </h1>
            </div>
        </div>
        <div class="column is-12" v-if="school">
            <div class="box">
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <h2>Lärare
                            <small class=" pull-right">Kod: {{school.teacher.code}}</small>
                        </h2>
                        <p>Denna kod är giltigt till {{school.teacher.valid_to}} <a
                                class="button is-small is-info pull-right"
                                @click="extendCode(school.teacher, 'teacher')">Förläng kod</a></p>
                        <h3>Aktiva enheter</h3>
                        <table class="table" v-if="school.teacher.active_codes.length > 0">
                            <thead>
                            <tr>
                                <th>
                                    Enhet
                                </th>
                                <th>
                                    Skapad
                                </th>
                                <th>
                                    Senast använd
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(code, key) in school.teacher.active_codes" :key="key">
                                <td>
                                    {{code.meta}}
                                </td>
                                <td>
                                    {{code.created_at}}
                                </td>
                                <td>
                                    {{code.updated_at}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <p v-else>Denna kod har inga aktiva sessioner</p>
                        <h3>Inaktiverade enheter</h3>
                        <table class="table" v-if="school.teacher.inactive_codes.length > 0">
                            <thead>
                            <tr>
                                <th>
                                    Enhet
                                </th>
                                <th>
                                    Skapad
                                </th>
                                <th>
                                    Senast använd
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(code, key) in school.teacher.inactive_codes" :key="key">
                                <td>
                                    {{code.meta}}
                                </td>
                                <td>
                                    {{code.created_at}}
                                </td>
                                <td>
                                    {{code.updated_at}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <p v-else>Denna kod har inga inaktiverade sessioner</p>
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="columns is-multiline">
                    <div class="column is-12">
                        <h2>Skolklass
                            <small class="pull-right">Kod: {{school.class.code}}</small>
                        </h2>
                        <p>Denna kod är giltigt till {{school.class.valid_to}} <a
                                class="button is-small is-info pull-right" @click="extendCode(school.class, 'class')">Förläng
                            kod</a></p>
                        <h3>Aktiva enheter</h3>
                        <table class="table" v-if="school.class.active_codes.length > 0">
                            <thead>
                            <tr>
                                <th>
                                    Enhet
                                </th>
                                <th>
                                    Skapad
                                </th>
                                <th>
                                    Senast använd
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(code, key) in school.class.active_codes" :key="key">
                                <td>
                                    {{code.meta}}
                                </td>
                                <td>
                                    {{code.created_at}}
                                </td>
                                <td>
                                    {{code.updated_at}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <p v-else>Denna kod har inga aktiva sessioner</p>
                        <h3>Inaktiverade enheter</h3>
                        <table class="table" v-if="school.class.inactive_codes.length > 0">
                            <thead>
                            <tr>
                                <th>
                                    Enhet
                                </th>
                                <th>
                                    Skapad
                                </th>
                                <th>
                                    Senast använd
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(code, key) in school.class.inactive_codes" :key="key">
                                <td>
                                    {{code.meta}}
                                </td>
                                <td>
                                    {{code.created_at}}
                                </td>
                                <td>
                                    {{code.updated_at}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <p v-else>Denna kod har inga inaktiverade sessioner</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    table.table {
        width: 100%;
    }

    table.table thead tr th:first-of-type {
        width: 50%;
    }
</style>
<script>
import modelMixin from '../mixins/model'

export default {
  name: 'School',
  mixins: [modelMixin],
  data () {
    return {
      school: null
    }
  },
  watch: {
    models: {
      handler: function (newVal, oldVal) {
        if (newVal.name === 'School') {
          this.data = newVal
        }
      },
      deep: true
    }
  },
  methods: {
    extendCode: function (data, type) {
      const that = this
      this.$store.dispatch('extendCode', { data })
        .then((response) => {
          console.log(response.data)
          that.school[type].valid_to = response.data.SchoolUser.valid_to
        })
        .catch((error) => {
          console.log(error)
        })
    },
    goBack: function () {
      this.$router.go(-1)
    }
  },
  computed: {},
  mounted () {
    this.school = this.models
  }
}
</script>
